import React, { useEffect, useState, useContext } from 'react';
import { Table } from 'react-bootstrap';
import classes from './index.module.scss';
import PostTableHeader from './PostTableHeader';
import BusinessPostTableBody from './BusinessPostTableBody';
import ContractOppPostTableBody from './ContractOppPostTableBody';
import { UserContext } from "../../context/User";
import { somethingWentWrongNotice } from '../UI/Notifications';
import { useHistory } from 'react-router';
import { Row, Col } from 'react-bootstrap';
import Pagination from '../Pagination';
import PageSwitcher from '../PageSwitcher';
import { SearchContext } from '../../context/Search';

const PostTableContainer = ({ setLoading, setDeleteTrigger, deleteTrigger, postHeaders, selectList, requests, role }) => {
  const [posts, setPosts] = useState([]);
  const [offset, setOffset] = useState(0);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const [totalCount, setTotalCount] = useState(0);
  const [forcePage, setForcePage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const limit = 10;

  const deletePost = id => {
    requests.delete({id})
      .then(response => {
        setDeleteTrigger(!deleteTrigger);
      })
      .catch(error => { 
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Dashboard");
    }
    setLoading(false);
  }

  const getPosts = () => {
    setLoading(true);
    requests.get({
      select: selectList,
      offset: offset
    })
    .then(response => {
      setPosts(response.data.results);
      setTotalCount(response.data.total_count);
      setLoading(false);
    })
    .catch(error => { 
      if (error.response.status !== 404) {
        handleDefaultStatusCodes(error.response.status);
      }
      setPosts([]);
      setTotalCount(0);
      setLoading(false);
    })
  }

  useEffect(() => {
    getPosts()
  }, [offset, deleteTrigger])

  return (
    <>
    {!!totalCount && (
      <div className={classes.Table_Wrapper}>
        <Table striped responsive className={classes.Table}>
          <thead className={classes.Table_Head}>
            <PostTableHeader 
              list={postHeaders}
            />
          </thead>
          <tbody className={classes.Table_Body}>
            {role === "business" && <BusinessPostTableBody list={posts} deletePost={deletePost} />}
            {role === "officer" && <ContractOppPostTableBody list={posts} deletePost={deletePost} />}
          </tbody>
        </Table>
        <SearchContext.Provider value={{offset, setOffset, totalCount, limit, setForcePage, forcePage, setPageCount, pageCount}}>
          {posts && !!posts.length && (
            <Row>
              <Col>
                <div className="pagination-wrap">
                  <Pagination />
                  <PageSwitcher />
                </div>
              </Col>
            </Row>
          )}
        </SearchContext.Provider>
      </div>
    )}
    </>
  )
}

export default PostTableContainer;